// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AlertBoxComponent, { AlertBoxType, alertBoxTypeOptions } from "@store/Library/Components/AlertBox";
import { getDataOptionsFieldDefinition } from "@toolkit/Framework/Common/Utilities/dataOptions";
import React, { FC } from "react";

const enum fields {
    type = "type",
    title = "title",
    secondaryText = "secondaryText",
    stackTitleAndSecondaryText = "stackTitleAndSecondaryText",
    showIcon = "showIcon",
    showInfoTooltip = "showInfoTooltip",
    tooltipText = "tooltipText",
}

export interface AlertBoxWidgetProps extends WidgetProps {
    fields: {
        [fields.type]: AlertBoxType;
        [fields.title]: string;
        [fields.secondaryText]: string;
        [fields.stackTitleAndSecondaryText]: boolean;
        [fields.showIcon]: boolean;
        [fields.showInfoTooltip]: boolean;
        [fields.tooltipText]: string;
    };
}

const AlertBox: FC<AlertBoxWidgetProps> = ({
    fields: { type, title, secondaryText, stackTitleAndSecondaryText, showIcon, showInfoTooltip, tooltipText },
}) => {
    return (
        <AlertBoxComponent
            type={type}
            title={title}
            secondaryText={secondaryText}
            stackTitleAndSecondaryText={stackTitleAndSecondaryText}
            showIcon={showIcon}
            tooltipText={showInfoTooltip ? tooltipText : undefined}
        />
    );
};

const widgetModule: WidgetModule = {
    component: AlertBox,
    definition: {
        displayName: "Alert Box",
        group: "Basic",
        icon: "circle-i",
        fieldDefinitions: [
            {
                ...getDataOptionsFieldDefinition(alertBoxTypeOptions),
                name: fields.type,
                displayName: "Type",
                fieldType: "Contextual",
                hideEmptyOption: true,
                tooltip: "Controls the alert color variant.",
            },
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                tooltip: "Primary message shown in bold.",
            },
            {
                name: fields.secondaryText,
                displayName: "Secondary Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                tooltip: "Supporting message shown next to or below the title.",
            },
            {
                name: fields.stackTitleAndSecondaryText,
                displayName: "Stack Title and Secondary Text",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tooltip: "When enabled, title and secondary text always render on separate lines.",
            },
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tooltip: "Shows the leading alert icon.",
            },
            {
                name: fields.showInfoTooltip,
                displayName: "Show Info Tooltip",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                tooltip: "Shows the trailing info icon with a hover tooltip.",
            },
            {
                name: fields.tooltipText,
                displayName: "Info Tooltip Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                tooltip: "Text displayed when hovering the info tooltip icon.",
                isVisible: widget => Boolean(widget.fields.showInfoTooltip),
            },
        ],
    },
};

export default widgetModule;
